<template>

    <div class="titulo">
        <div class="margem container">
            <div class="m-icone direita"><button @click="abrirProjeto('criar')" class="acao-secundaria"> Novo
                    Projeto</button></div>
            <div class="m-icone direita">
                <div class="pesquisa-toolbar">
                    <div class="pesquisa">
                        <input type="text" placeholder="Pesquisar Projeto" v-model="termoBusca"
                            @input="filtrarProjetos" />
                        <a disabled class="icone-pesquisa"></a>
                    </div>
                    <button v-if="Number(id) === 0 && podeExportarControleExcel" type="button"
                        class="botao-export-excel" style="margin-right:1rem;" :disabled="exportando || loading"
                        title="Exportar Excel (filtros atuais)" @click.prevent="baixarExportControle">
                        <span class="mdi mdi-microsoft-excel"></span>
                    </button>
                </div>
            </div>
            <h2>Projetos</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="bloco margem">
            <table class="tabela">
                <tbody>
                    <tr>
                        <th @click="ordenarLista('pcm_codigo')"> Código <i v-if="sortKey === 'pcm_codigo'"
                                :class="sortOrder === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'">
                            </i>
                        </th>
                        <th @click="ordenarLista('nome')"> Nome do Projeto <i v-if="sortKey === 'nome'"
                                :class="sortOrder === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'">
                            </i>
                        </th>
                        <th> Status <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ props }">
                                    <span class="mdi mdi-filter-variant fonte-maior icone"
                                        :class="{ 'ativo': !(statusDisponiveis.every(v => filtroStatus.includes(v))) }"
                                        v-bind="props"></span>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <div style="display: flex; flex-flow: column; gap: .5rem;">
                                            <div class="alinha-v" v-for="s in statusDisponiveis" :key="s">
                                                <input type="checkbox" :id="s" v-model="filtroStatus" :value="s">
                                                <label :for="s" style="margin-bottom: 0"> {{ rotuloStatusProjeto(s) }}</label>
                                            </div>
                                        </div>
                                    </v-list-item>
                                    <div style="display: flex; justify-content: center;">
                                        <span class="chip bg-sucesso" @click="aplicarFiltroStatus">Filtrar</span>
                                    </div>
                                </v-list>
                            </v-menu>
                        </th>
                        <th @click="ordenarLista('dtInicio')"> Data de Início <i v-if="sortKey === 'dtInicio'"
                                :class="sortOrder === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'">
                            </i>
                        </th>
                        <th @click="ordenarLista('dtTermino')"> Data de Término <i v-if="sortKey === 'dtTermino'"
                                :class="sortOrder === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'">
                            </i>
                        </th>
                        <th @click="ordenarLista('gerente')" class="text-nowrap"> Gerente Responsável <i
                                v-if="sortKey === 'gerente'"
                                :class="sortOrder === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'">
                            </i>
                        </th>
                        <th @click="ordenarLista('setor')"> Setor Beneficiado <i v-if="sortKey === 'setor'"
                                :class="sortOrder === 'asc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'">
                            </i>
                        </th>
                        <th></th>
                    </tr>
                    <template v-if="!loading">
                        <tr v-for="item in projetosOrdenados" :key="item.id" @click="abrirProjeto(item.id)">
                            <td> {{ item.pcm_codigo ?? '-' }}</td>
                            <td>{{ item.nome }}</td>
                            <td>
                                <!-- <select v-model="item.status" v-if="this.idUsuario === item.gerente_id || isAuditor"
                                    :style="{ 'color': corStatus(item.status) }" @click.stop
                                    @change="editarStatus(item.id, item.status)">
                                    <option style="color: #FFA500" hidden :value="'Proposto'">Aguardando
                                        Aprovação </option>
                                    <option style="color: #00B6B3;" hidden>Aprovado</option>
                                    <option style="color: var(--cor-ok);">Em andamento</option>
                                    <option style="color: var(--cor-sucesso);">Concluído</option>
                                    <option style="color: #FFA500">Suspenso</option>
                                    <option style="color: var(--cor-erro)">Cancelado</option>
                                    <option style="color: var(--cor-erro)" hidden>Reprovado</option>
                                    <option style="color: #FFA500" hidden>Aguardando Entregas</option>
                                </select>
                                <span v-else style="white-space: nowrap" :style="{ 'color': corStatus(item.status) }">
                                    {{ item.status }} </span> -->
                                <span style="white-space: nowrap" :style="{ 'color': corStatus(item.status) }">
                                    {{ rotuloStatusProjeto(item.status) }} </span>
                            </td>
                            <td> {{ formatarData(item.dtInicio) }} </td>
                            <td> {{ formatarData(item.dtTermino) }} </td>
                            <td> {{ item.gerente?.name }} </td>
                            <td>{{ item.setor?.nome }}</td>
                            <td>
                                <v-menu>
                                    <template v-slot:activator="{ props }">
                                        <v-btn class="botaoOpções acao-secundaria" icon="mdi-dots-horizontal"
                                            v-bind="props" v-if="isAuditor">
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item class="txt-erro" @click="excluirProjeto(item)"> Excluir
                                            Projeto </v-list-item>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="7">
                            <div class="loading">
                                <div></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="paginacao-container">
                <div class="paginacao">
                    <template v-for="l in links" :key="l">
                        <a v-if="l.label !== 'pagination.previous' && l.label !== 'pagination.next'"
                            :class="{ 'ativo': l.active }" @click="paginaAtual = l.label; getProjetos()"> {{
                                l.label }} </a>
                        <span v-else-if="l.label === 'pagination.previous'"
                            @click="l.url ? (paginaAtual = parseInt(paginaAtual) - 1, getProjetos()) : null">
                            <i class="icon bi-caret-left-fill"></i>
                        </span>
                        <span v-else-if="l.label === 'pagination.next'"
                            @click="l.url ? (paginaAtual = parseInt(paginaAtual) + 1, getProjetos()) : null">
                            <i class="icon bi-caret-right-fill"></i>
                        </span>
                    </template>
                </div>
                <div class="paginacao-select" v-if="links?.length > 0">
                    <label>Qtd p/ página</label>
                    <select v-model="qtPorPagina" @change="paginaAtual = '1'; getProjetos()">
                        <option>15</option>
                        <option>20</option>
                        <option>50</option>
                        <option>100</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { dataParaInput, formatarDataBr } from "@/utils/date";
import { downloadFromArrayBuffer } from "@/utils/download";
import { useApiError } from "@/composables/useApiError";
import { consultarSetores } from "@/services/usuario-setor";
import { sso } from "roboflex-thalamus-sso-lib";
import { getPermissao } from "@/services/permissao-service";
import serviceProjetos from "@/services/serviceProjetos";
import servicePCM from "@/services/servicePCM";
import { useOrdenacaoColuna } from "@/composables/useOrdenacaoColuna";
import {
    montarChaveCacheLista,
    obterCacheLista,
    gravarCacheLista,
} from "@/utils/cacheListaMemoria";

export default {
    name: "controleDeProjetos",

    setup() {
        const { handleError } = useApiError();
        const { sortKey, sortOrder, toggleOrdenacao } = useOrdenacaoColuna('status', 'asc');
        return {
            handleApiError: handleError,
            sortKey,
            sortOrder,
            toggleOrdenacao,
            obterCacheLista,
            gravarCacheLista,
        };
    },

    props: {
        id: { required: false, default: 0 }
    },
    watch: {
        id() {
            this.restaurarFiltro()
            if (Number(this.id) === 0) {
                this.getProjetos()
            } else {
                this.getProjetosDePrograma()
            }
        },
    },
    data() {
        return {
            debounceTimer: null,
            requisicaoProjetosSeq: 0,
            exportando: false,
            idUsuario: null,
            projetos: [],
            gerente: [],
            setores: [],
            permissoes: [],
            termoBusca: '',
            loading: true,
            paginaAtual: '1',
            qtPorPagina: 15,
            filtroStatus: [
                'Aprovado',
                'Em andamento',
                'Proposto',
            ],
            statusDisponiveis: [
                'Aprovado',
                'Em andamento',
                'Proposto',
                'Suspenso',
                'Concluído',
                'Cancelado',
                'Reprovado'
            ]
        }
    },

    computed: {
        projetosOrdenados() {
            if (!this.projetos) return []

            let resultado = this.projetos;

            // if (this.termoBusca.trim()) {
            //     const busca = this.termoBusca.trim().toLowerCase();
            //     resultado = resultado.filter(proj =>
            //         JSON.stringify(proj)
            //             .toLowerCase()
            //             .includes(busca)
            //     );
            // }

            //Ordenação
            if (!this.sortKey) return resultado;

            return [...resultado].sort((a, b) => {
                const key = this.sortKey;
                let valA = a[key];
                let valB = b[key];

                if (key === 'dtInicio' || key === 'dtTermino') {
                    valA = new Date(valA || '1900-01-01');
                    valB = new Date(valB || '1900-01-01');
                }

                if (key === 'status') {
                    const ordemStatus = {
                        'Proposto': 1,
                        'Aguardando Aprovação': 2,
                        'Aguardando Entregas': 3,
                        'Em andamento': 4,
                        'Aprovado': 5,
                        'Suspenso': 6,
                        'Concluído': 7,
                        'Cancelado': 8,
                        'Reprovado': 9
                    };
                    valA = ordemStatus[valA] || 99;
                    valB = ordemStatus[valB] || 99;
                }

                if (valA == null) return this.sortOrder === 'asc' ? 1 : -1;
                if (valB == null) return this.sortOrder === 'asc' ? -1 : 1;

                if (typeof valA === 'string' && typeof valB === 'string') {
                    return this.sortOrder === 'asc'
                        ? valA.localeCompare(valB)
                        : valB.localeCompare(valA);
                }

                return this.sortOrder === 'asc' ? valA - valB : valB - valA;
            });
        },
        isAuditor() {
            return this.permissoes.includes(116)
        },
        /** Funcionalidade 210 — exportação XLSX do controle de projetos. */
        podeExportarControleExcel() {
            return this.permissoes.includes(210)
        }
    },

    async mounted() {
        this.permissoes = await getPermissao()
        this.restaurarFiltro()
        if (Number(this.id) === 0) {
            this.getProjetos()
        } else {
            this.getProjetosDePrograma()
        }
        this.getGerenteseSetor()
    },

    beforeUnmount() {
        clearTimeout(this.debounceTimer)
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id
    },

    methods: {
        rotuloStatusProjeto(status) {
            if (status === 'Aguardando Entregas') return 'Aguardando pacotes de trabalho'
            return status
        },
        corStatus(status) {
            let cor;
            switch (status) {
                case 'Cancelado':
                case 'Reprovado':
                    cor = 'var(--cor-erro)';
                    break;
                case 'Proposto':
                    cor = '#FFA500';
                    break;
                case 'Aprovado':
                    cor = '#00B6B3';
                    break;
                case 'Em andamento':
                    cor = 'var(--cor-ok)';
                    break;
                case 'Concluído':
                    cor = 'var(--cor-sucesso)';
                    break;
                case 'Suspenso':
                    cor = '#FFA500';
                    break;
                default:
                    cor = '#FFA500';
            }
            return cor;
        },
        formatarData(data) {
            return formatarDataBr(data);
        },

        ordenarLista(chaveColuna) {
            this.toggleOrdenacao(chaveColuna);
            this.salvarFiltro()
        },

        async excluirProjeto(item) {
            if (confirm(`Deseja mesmo excluir o projeto ${item.nome}?`)) {
                await serviceProjetos.excluirProjeto(item.id, this.idUsuario);
                await servicePCM.excluirPCM(item.pcm_id, this.idUsuario);
                this.getProjetos()
            }
        },

        editarStatus(idProjeto, novoValor) {
            var payload = {}
            if (novoValor !== "Concluído") {
                payload = {
                    status: novoValor,
                    dtTermino: null
                }
            }
            if (novoValor === "Concluído") {
                payload = {
                    status: novoValor,
                    dtTermino: dataParaInput(new Date().toISOString())
                }
            }

            serviceProjetos.atualizarProjeto(idProjeto, payload)
        },

        abrirProjeto(id) {
            this.salvarFiltro()
            this.$router.push({ name: 'projetoView', params: { idProjeto: id } })
        },

        chaveStorageFiltro() {
            return `controleProjetosFiltro:${Number(this.id) || 0}`
        },

        salvarFiltro() {
            if (Number(this.id) !== 0) return
            try {
                sessionStorage.setItem(this.chaveStorageFiltro(), JSON.stringify({
                    termoBusca: this.termoBusca,
                    filtroStatus: this.filtroStatus,
                    paginaAtual: this.paginaAtual,
                    qtPorPagina: this.qtPorPagina,
                    sortKey: this.sortKey,
                    sortOrder: this.sortOrder,
                }))
            } catch {
                // Ignora falha de storage
            }
        },

        restaurarFiltro() {
            if (Number(this.id) !== 0) return
            try {
                const raw = sessionStorage.getItem(this.chaveStorageFiltro())
                if (!raw) return
                const filtro = JSON.parse(raw)
                if (filtro.termoBusca != null) this.termoBusca = filtro.termoBusca
                if (Array.isArray(filtro.filtroStatus)) {
                    const ocultos = ['Aguardando Aprovação', 'Aguardando Entregas']
                    this.filtroStatus = filtro.filtroStatus.filter((status) => !ocultos.includes(status))
                }
                if (filtro.paginaAtual != null) this.paginaAtual = String(filtro.paginaAtual)
                if (filtro.qtPorPagina != null) this.qtPorPagina = filtro.qtPorPagina
                if (filtro.sortKey) this.sortKey = filtro.sortKey
                if (filtro.sortOrder) this.sortOrder = filtro.sortOrder
            } catch {
                // Ignora filtro inválido
            }
        },

        async getGerenteseSetor() {
            try {
                const { usuarios, setores } = await consultarSetores();
                this.gerente = usuarios;
                this.setores = setores;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getProjetosDePrograma() {
            const chave = montarChaveCacheLista('controleProjetosPrograma', {
                userId: this.idUsuario,
                programaId: Number(this.id) || 0,
            });
            const cached = this.obterCacheLista(chave);
            if (cached) {
                this.projetos = cached.projetos;
                this.links = [];
                this.loading = false;
                return;
            }

            this.loading = true;
            try {
                this.projetos = await serviceProjetos.listarProjetosPrograma(this.id);
                this.links = [];
                this.gravarCacheLista(chave, { projetos: this.projetos });
            } finally {
                this.loading = false;
            }
        },

        filtrarProjetos() {
            clearTimeout(this.debounceTimer)
            this.debounceTimer = setTimeout(() => {
                this.paginaAtual = '1'
                this.getProjetos()
            }, 500)
        },

        aplicarFiltroStatus() {
            this.paginaAtual = '1'
            this.getProjetos()
        },

        chaveCacheProjetos() {
            return montarChaveCacheLista('controleProjetos', {
                userId: this.idUsuario,
                programaId: Number(this.id) || 0,
                status: [...(this.filtroStatus || [])].slice().sort(),
                page: String(this.paginaAtual),
                perPage: Number(this.qtPorPagina) || 15,
                search: String(this.termoBusca || '').trim(),
            });
        },

        async getProjetos() {
            const seq = ++this.requisicaoProjetosSeq
            this.salvarFiltro()

            const chave = this.chaveCacheProjetos();
            const cached = this.obterCacheLista(chave);
            if (cached) {
                if (seq !== this.requisicaoProjetosSeq) return
                this.projetos = cached.projetos
                this.links = cached.links
                this.loading = false
                return
            }

            this.loading = true
            try {
                const response = await serviceProjetos.listarProjetosUsuario(
                    this.idUsuario,
                    this.filtroStatus,
                    this.paginaAtual,
                    this.qtPorPagina,
                    this.termoBusca,
                )
                if (seq !== this.requisicaoProjetosSeq) return
                this.projetos = response.data
                this.links = response.links
                this.gravarCacheLista(chave, {
                    projetos: this.projetos,
                    links: this.links,
                })
            } catch (error) {
                if (seq !== this.requisicaoProjetosSeq) return
                this.handleApiError(error)
            } finally {
                if (seq === this.requisicaoProjetosSeq) {
                    this.loading = false
                }
            }
        },

        async baixarExportControle() {
            if (Number(this.id) !== 0 || !this.podeExportarControleExcel || this.exportando) {
                return;
            }
            this.exportando = true;
            try {
                const response = await serviceProjetos.exportarControleProjetosXlsx(
                    this.idUsuario,
                    this.filtroStatus,
                    this.termoBusca
                );
                const nome = `controle-projetos-${new Date().toISOString().slice(0, 10)}.xlsx`;
                downloadFromArrayBuffer(response.data, nome);
            } catch (error) {
                this.handleApiError(error);
            } finally {
                this.exportando = false;
            }
        }
    }

}
</script>
<style scoped>
.pesquisa-toolbar {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.botao-export-excel {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    padding: 0;
    border: 1px solid var(--cor-separador);
    border-radius: 8px;
    cursor: pointer;
}

.botao-export-excel:hover:not(:disabled) {
    box-shadow: 0 0 0 1px var(--cor-primaria-media, #00a86b);
}

.botao-export-excel:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.botao-export-excel .mdi {
    font-size: 1.35rem;
}

td {
    select {
        width: fit-content;
    }
}

.botaoOpções {
    visibility: hidden;
    width: 2rem !important;
    height: 2rem !important;
    border: 1px solid var(--cor-separador) !important;
    color: var(--cor-fonte) !important;
}

.icone.ativo {
    border-bottom: 2px solid var(--cor-ok);
}

tr:hover {
    .botaoOpções {
        visibility: visible;
    }
}

th {
    cursor: pointer;
}
</style>